import { CVType, AddCVType } from "@jobintrans/base-ui.types.api"
import { APIService } from "./APIService"

const create = () => APIService.post<null, CVType>(`/accounts/:accountId/cv`)
const update = (id: string, body: AddCVType) =>
  APIService.patch<null, CVType>(`/accounts/:accountId/cv/${id}`, body)
const get = (id: string) => APIService.get<null, CVType>(`/accounts/:accountId/cv/${id}`)

export const CVService = {
  create,
  update,
  get,
}
